import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Link, useParams } from "react-router-dom";
import YouTube from "react-youtube";
import { apiGetSingleVideo, IVideo } from "../api/controllers/get-video-list";
import GlobalHelmetProvider from "../components/global/GlobalHelmetProvider";
import { youtube_parser } from "../utils/youtube-url-parser";
import PageNotFound from "./404";

const SingleVideo = () => {
  const { videoId } = useParams() || {};
  const [video, setVideo] = useState<IVideo>();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!videoId) return;
    setLoading(true);
    setError(false);
    apiGetSingleVideo(videoId)
      .then((r) => setVideo(r.data[0]))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [videoId]);

  if (loading) return <main className="page" />;
  if (error || !video) return <PageNotFound text="Video not found" />;

  const a = video.attributes;
  const sections = [
    { key: "credits", title: "Credits", body: a.credits },
    { key: "sources", title: "Sources", body: a.refrences },
  ].filter((s) => s.body && s.body.trim());

  return (
    <main className="page video-page">
      <GlobalHelmetProvider title={a.title} description={a.description} />
      <p className="crumb">
        <Link to="/videos">Videos</Link>
      </p>
      <div className="video-frame">
        <YouTube videoId={youtube_parser(a.video_id)} title={a.title} opts={{ width: "100%", height: "100%" }} />
      </div>
      <h1 className="video-title">{a.title}</h1>
      {a.description && (
        <div className="video-desc">
          <ReactMarkdown>{a.description}</ReactMarkdown>
        </div>
      )}
      {sections.map((s) => (
        <section className="video-section" key={s.key}>
          <h2>{s.title}</h2>
          <div className="video-section-body">
            <ReactMarkdown>{s.body}</ReactMarkdown>
          </div>
        </section>
      ))}
    </main>
  );
};

export default SingleVideo;
